<template>
	<div class="">
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="30%" append-to-body :close-on-click-modal="false"
			class="dialogClass">
			<div class="flexjcen" style="margin-bottom: 10px;" v-for="(item,index) in tableData" :key="index">
				<div class="flexjcen">
					<img class="store" :src="item.cover" alt="">
					<div class="godwin">
						<div class="sizetxt">
							{{item.name}}
						</div>
						<div>{{item.specifications}}</div>
					</div>
				</div>
				<div class="">
					<div class="sizetxt red">
						￥{{item.price}}
					</div>
					<div class="">
						x {{item.number}}
					</div>
				</div>
			</div>
			<div style="height: 20px;"></div>
			<div class="issline"></div>
			<div style="height: 20px;"></div>
			<div class="flexjcen">
				<div class="">
					实付款
				</div>
				<div class="redmony">
					￥{{editForm.realPayment}}
				</div>
			</div>
			<div style="height: 20px;"></div>
			<div class="issline"></div>
			<div style="height: 20px;"></div>
			<div class="flexcen">
				<div class="titcon">
					配送方式
				</div>
				<div class="">
					{{editForm.deliveryMethod==1?'自提':editForm.deliveryMethod==2?'货拉拉':'物流'}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryMethod==1||editForm.deliveryMethod==2" >
				<div class="titcon">
					门店
				</div>
				<div class="" >
					 {{editForm.address}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryMethod==1||editForm.deliveryMethod==2">
				<div class="titcon" v-if="editForm.defName">
					提货人
				</div>
				<div class="" v-if="editForm.defName">
					{{editForm.defName}} {{editForm.defPhone}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryMethod==3&&editForm.logisticsNumber!=null" >
				<div class="titcon">
					物流单号
				</div>
				<div class="" v-if="editForm.logisticsNumber!=null">
					{{editForm.logisticsNumber}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryMethod==3">
				<div class="titcon">
					收货人
				</div>
				<div class="">
					{{editForm.name}} {{editForm.phone}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryMethod==3">
				<div class="titcon">
					收货地址
				</div>
				<div class="">
					{{editForm.province}} {{editForm.city}} {{editForm.county}} {{editForm.address}}
				</div>
			</div>
			<!-- <div class="flexcen"  v-if="editForm.logisticsNumber!=null"  @click="getlocinfo(editForm.logisticsNumber)">
				<div class="titcon">
					物流详情
				</div>
				<div class="conend" v-if="infoyent[radio].tlogisticsDetails!=null">
					{{infoyent[radio].tlogisticsDetails.acceptStation}}
				</div>
			</div> -->
			<div style="height: 20px;"></div>
			<div class="issline"></div>
			<div style="height: 20px;"></div>
			<div class="flexcen">
				<div class="titcon">
					创建时间
				</div>
				<div class="">
					{{editForm.createTime}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.payTime">
				<div class="titcon">
					付款时间
				</div>
				<div class="">
					{{editForm.payTime}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.deliveryTime">
				<div class="titcon">
					发货时间
				</div>
				<div class="">
					{{editForm.deliveryTime}}
				</div>
			</div>
			<div class="flexcen">
				<div class="titcon">
					收货信息
				</div>
				<div class="">
					{{editForm.consignee}} {{editForm.phone}} {{editForm.address}}
				</div>
			</div>
			<div class="flexcen" v-if="editForm.trasactionId">
				<div class="titcon">
					交易编号
				</div>
				<div class="">
					{{editForm.trasactionId}}
				</div>
			</div>
			<div class="flexcen">
				<div class="titcon">
					订单编号
				</div>
				<div class="">
					{{editForm.orderCode}}
				</div>
			</div>
		</el-dialog>
		<el-dialog title="订单详情" :visible.sync="visible" width="700px" append-to-body :close-on-click-modal="false"
			class="dialogClass">
			<div >
			  <el-steps direction="vertical" :active="0">
			    <el-step :title="items.acceptTime" :description="items.acceptStation" v-for="(items,indexs) in listaudio.logisticsDetails" ></el-step>
			  </el-steps>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
	import TinymceEditor from "../inc/TinymceEditor";
import VploadVideo from "../inc/VploadVideo.vue";
	export default {
		name: "BillDetails",
		components: {
			TinymceEditor,
			VploadVideo
		},
		data() {
			return {
				editForm: {},
				fileList: [],
				tableData: [],
				urlList: [],
				videoList: [],
				radio:0,
				videoUrlList: [],
				infoyent:"",
				editFormRules: {
					value: [{
						required: true,
						message: '请选择群二维码',
						trigger: 'blur'
					}]
				},
				dialogVisible: false,
				visible: false,
				listaudio:"",
			}
		},
		methods: {
			change(val) {
				this.editForm.describe = val;
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
				this.fileList = [];
				this.urlList = []
				this.tableData = []
				this.videoList = []
				this.videoUrlList = []
			},
			handleClose() {
				this.resetForm('editForm')
			},
			getlocinfo(e){
				this.$axios.post('/sysOrder/getLogistics', {trackingNumber:e})
					.then(res => {
						this.listaudio =res.data
						this.visible = true	
					})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/admin/mcMuseumCollection/updMcMuseumCollectionDetails', this.editForm)
							.then(res => {
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose: () => {
										this.$emit('refreshDataList')
									}
								});
								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						return false;
					}
				});
			},
			getImgList(url, add) {
				if (add == 1) {
					this.urlList.push(url)
				} else if (add == 0) {
					if (this.urlList == null || this.urlList.length < 1) {
						return;
					}
					this.urlList.some((item, i) => {
						if (item == url) {
							this.urlList.splice(i, 1)
							return true
						}
					})
				}
				this.editForm.filePath = this.urlList.join(",")
			},
			getvideoList() {
				if (add == 1) {
					this.videoUrlList.push(url)
				} else if (add == 0) {
					if (this.videoUrlList == null || this.videoUrlList.length < 1) {
						return;
					}
					this.videoUrlList.some((item, i) => {
						if (item == url) {
							this.videoUrlList.splice(i, 1)
							return true
						}
					})
				}
				this.editForm.filePath = this.videoUrlList.join(",")
			},
			init(billId) {
				this.dialogVisible = true;
				this.radio = 0
				if (billId != null && billId != '') {
					this.$axios.post('/admin/order/getOrderDetail', {
						orderCode: billId
					}).then(res => {
						this.editForm = res.data
						this.tableData = res.data.tcommodityVos	
					})
					// this.$axios.post('/sysOrder/getLogisticsTrackingNumber', {
					// 	id: billId
					// }).then(res => {
					// 	this.infoyent =res.data
					// })
					
				}
			},
		}
	}
</script>

<style scoped>
	.flexjcen {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.flexcen {
		display: flex;
		align-items: center;
		margin-bottom: 6px;
	}

	.store {
		width: 60px;
		height: 60px;
		border-radius: 6px;
	}

	.godwin {
		padding-left: 10px;
	}

	.sizetxt {
		height: 40px;
		line-height: 20px;
		font-size: 14px;
	}

	.red {
		color: #D9001B;
		font-weight: 800;
		font-size: 16px;
	}

	.issline {

		height: 1px;
		background: #e1e1e1;
		width: 100%;
	}

	.redmony {
		color: #D9001B;
		font-size: 16px;
	}

	.titcon {
		width: 150px;
	}
	.padser{
		display: flex;
		align-items: center;
		
	}
	.imgstxt{
		width: 80px;
		
		
	}
	.conend{
		color: #4293FE;
	}
</style>